import { DistributionActions } from '../actions/distribution'

export const DISTRIBUTION_REDUCER_NAMESPACE = 'distributionReducer'

export interface DistributionState {
    filtersOptionsMap: Record<string, any[]>
}

const defaultState: DistributionState = {
    filtersOptionsMap: {},
}

export default (state = defaultState, action: any) => {
    switch (action.type) {
        case DistributionActions.SET_FILTERS_OPTIONS_MAP: {
            return {
                ...state,
                filtersOptionsMap: action.filtersOptionsMap,
            }
        }
        default:
            return state
    }
}
